// import PropTypes from 'prop-types';

export const DIVIDER_TYPES = {
  DEFAULT: 'default',
  DASHED: 'dashed',
};
